import { render } from "./gorusmebilgiForm.vue?vue&type=template&id=4d968510"
import script from "./gorusmebilgiForm.vue?vue&type=script&lang=js"
export * from "./gorusmebilgiForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__